import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  Paper,
} from '@mui/material';
import { RiSmartphoneLine, RiComputerLine } from '@remixicon/react';
import { setOrientation, setDesignMode } from '../redux/slices/canvasSlice';

const OrientationSelector = () => {
  const dispatch = useDispatch();
  const { orientation, designMode, dimensions } = useSelector((state) => state.canvas);
  
  const handleOrientationChange = (event, newOrientation) => {
    if (newOrientation !== null) {
      dispatch(setOrientation(newOrientation));
    }
  };
  
  const handleDesignModeChange = (event, newMode) => {
    if (newMode !== null) {
      dispatch(setDesignMode(newMode));
    }
  };
  
  const currentDimensions = dimensions[orientation];
  
  return (
    <Paper
      elevation={2}
      sx={{
        padding: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 3,
        backgroundColor: 'white',
        borderRadius: 2,
      }}
    >
      {/* Orientation Selector */}
      <Box>
        <Typography variant="caption" color="text.secondary" sx={{ marginBottom: 1, display: 'block' }}>
          Orientation
        </Typography>
        <ToggleButtonGroup
          value={orientation}
          exclusive
          onChange={handleOrientationChange}
          size="small"
        >
          <ToggleButton value="landscape" aria-label="landscape">
            <RiComputerLine size={18} style={{ marginRight: 8 }} />
            Landscape
          </ToggleButton>
          <ToggleButton value="portrait" aria-label="portrait">
            <RiSmartphoneLine size={18} style={{ marginRight: 8 }} />
            Portrait
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
      
      {/* Design Mode Selector */}
      <Box>
        <Typography variant="caption" color="text.secondary" sx={{ marginBottom: 1, display: 'block' }}>
          Design Mode
        </Typography>
        <ToggleButtonGroup
          value={designMode}
          exclusive
          onChange={handleDesignModeChange}
          size="small"
        >
          <ToggleButton value="image" aria-label="image">
            Image
          </ToggleButton>
          <ToggleButton value="video" aria-label="video">
            Video
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
      
      {/* Dimensions Display */}
      <Box sx={{ marginLeft: 'auto' }}>
        <Typography variant="caption" color="text.secondary">
          Canvas Size
        </Typography>
        <Typography variant="body2" fontWeight={600}>
          {currentDimensions.width} × {currentDimensions.height}
        </Typography>
      </Box>
    </Paper>
  );
};

export default OrientationSelector;



